import React, { useEffect } from 'react';

import { LoadingSpinner, Page } from '../../components/layouts';
import { Over18Dialog } from '../../components/partials';
import { DispatchProps, StateProps } from '../../weborder/component/Over18';
import { RouteParams } from '../../weborder/Routes';

type Props = DispatchProps & StateProps & RouteParams;

export function Over18(props: Props): JSX.Element {
  const {
    BasketItems,
    Customer,
    LoadRestaurant,
    menuId,
    params,
    PushLoginUrl,
    RemoveItemFromBasket,
    Restaurant,
    translate,
    UpdateCustomer,
  } = props;

  useEffect(() => {
    if (Restaurant.status !== 'success') {
      LoadRestaurant(props);
    }
  }, [Restaurant.status]);

  if (Restaurant.status !== 'success') {
    return <LoadingSpinner />;
  }

  return (
    <Page pageName="over-18-dialog">
      <Over18Dialog
        basketItems={BasketItems}
        customer={Customer}
        menuId={menuId}
        params={params}
        pushLoginUrl={PushLoginUrl}
        removeItemFromBasket={RemoveItemFromBasket}
        restaurantData={Restaurant.data}
        translate={translate}
        updateCustomer={UpdateCustomer}
      />
    </Page>
  );
}
